import {ContentListBaseContainer} from './content-list-base-container';
import {SearchContainer} from '../search-container';
import {OperationContainer} from '../operation-container';

export class ContentListContainer implements ContentListBaseContainer {
  searchContainer: SearchContainer;
  operationContainer: OperationContainer;
  refreshCallback;
}
